/* Produktseite (sections/cmp-pdp.liquid): die Options-Buttons für Carrier Colour und Size — Auswahl, erreichbare
   Werte, das Event cmp:choose-carrier-colour —, die Galerie (Wischen, Vorschaubilder, nach Farbe gefiltert), die
   Info-Fenster (.cmp-modal), die A/B-Vorschau ?trust=a|b und die voraussichtliche Lieferung. Bis #416 stand das inline
   in der Sektion; es findet seine Sektion über `data-section-id` und liest die Varianten aus `data-cmp-pdp-variants`. */
(function () {
  var root = document.querySelector('.cmp-pdp[data-section-id]');
  if (!root || root.dataset.cmpInit) return;
  root.dataset.cmpInit = '1';
  var sid = root.dataset.sectionId;
  var variants = JSON.parse(document.querySelector('[data-cmp-pdp-variants="' + sid + '"]').textContent);
  var groups = root.querySelectorAll('[data-cmp-option]');
  var hints = { 'S': '19–26 cm', 'M': '25–36 cm', 'L': '34–52 cm' };

  function selected() {
    var sel = [];
    groups.forEach(function (g) {
      var active = g.querySelector('.is-active');
      sel[Number(g.dataset.cmpOption)] = active ? active.dataset.cmpValue : null;
    });
    return sel;
  }
  /* Passt eine Variante zur Auswahl? Mit `before` nur in den Optionen vor dieser
     Position — die eine Regel für Suchen, Erreichbarkeit und Nachrücken (#20). */
  function matches(v, sel, before) {
    return v.options.every(function (o, i) {
      return (before != null && i >= before) || sel[i] == null || o === sel[i];
    });
  }
  function findVariant(sel) {
    return variants.find(function (v) { return matches(v, sel); });
  }
  /* Zweite Charge (snippets/cmp-preorder-restock): „Nur noch 2 Stück aus der ersten Lieferung“, oder die Box für eine
     Variante, deren erste Lieferung verkauft ist, mit den Farben, die es in derselben Größe noch daraus gibt. */
  function stock(v) {
    var low = root.querySelector('[data-cmp-preorder-low]');
    var box = root.querySelector('[data-cmp-preorder-restock]');
    if (!low || !box) return;
    var shown = v.available && v.preorder;
    low.hidden = !(shown && v.left != null);
    if (!low.hidden) low.lastChild.textContent = low.dataset.cmpTemplate.replace('%COUNT%', v.left);
    box.hidden = !(shown && v.restock != null);
    /* Für „Benachrichtige mich“ (snippets/cmp-preorder-restock): die Variante, und das Feld wieder zu. */
    var notify = box.querySelector('[data-cmp-notify]');
    if (notify && box.dataset.cmpRestockVariantId !== String(v.id)) {
      notify.dataset.state = 'closed';
      notify.querySelector('[data-cmp-notify-open]').setAttribute('aria-expanded', 'false');
    }
    box.dataset.cmpRestockVariantId = v.id;
    box.dataset.cmpVariant = v.options.join(' / ');
    box.dataset.cmpRestockDate = v.restockDate || '';
    if (box.hidden) return;
    /* Aus Liquid, mit escapten Varianten-Namen: „vollständig ausverkauft“ steht in <strong>. */
    box.querySelector('[data-cmp-restock-text]').innerHTML = v.restock;
    var alts = box.querySelector('[data-cmp-restock-alts]');
    alts.textContent = '';
    (v.alts || []).forEach(function (color) {
      var swatch = valueButton('.cmp-pdp__swatches', color);
      if (!swatch) return;
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'cmp-preorder-restock__alt';
      chip.dataset.cmpRestockAlt = color;
      var dot = document.createElement('i');
      if (swatch.dataset.cmpHex) dot.style.background = swatch.dataset.cmpHex;
      chip.appendChild(dot);
      chip.appendChild(document.createTextNode(color));
      alts.appendChild(chip);
    });
    alts.parentNode.hidden = !alts.children.length;
  }
  function update() {
    var v = findVariant(selected());
    /* Die gewählte Carrier Variant für den Konfigurator: nur die id, leer wenn die
       Optionskombination keine Variante trifft (siehe cmp-configurator). */
    var mount = root.querySelector('[data-cmp-configurator]');
    if (mount) mount.setAttribute('data-cmp-carrier-variant', v ? String(v.id) : '');
    if (!v) return;
    /* Die gewählte Variante steht in der URL (`?variant=`), die Liquid beim Laden über
       `selected_or_first_available_variant` wieder auswählt: ein Reload, oder ein Tab,
       den das Handy verworfen hat, öffnet dieselbe Farbe und Größe statt der ersten
       verfügbaren — und ein wiederhergestellter Draft (#11) landet auf dem Halsband,
       für das er zusammengestellt wurde. `replaceState`, damit jeder Klick auf einen
       Swatch keinen Eintrag im Zurück-Verlauf hinterlässt. */
    var url = new URL(window.location.href);
    if (url.searchParams.get('variant') !== String(v.id)) {
      url.searchParams.set('variant', String(v.id));
      history.replaceState(history.state, '', url.toString());
    }
    root.querySelector('[data-cmp-variant-id]').value = v.id;
    var priceEl = document.getElementById('cmp-pdp-price-' + sid);
    priceEl.innerHTML = (v.compare ? '<s>' + v.compare + '</s> ' : '')
      + '<strong>' + v.price + '</strong>'
      + (v.rabatt ? ' <span class="cmp-pdp__price-badge">' + (v.preorder ? root.dataset.tSavePreorder : root.dataset.tSave).replace('%AMOUNT%', v.rabatt) + '</span>' : '');
    var cta = root.querySelector('[data-cmp-cta]');
    var gcValue = root.querySelector('[data-cmp-gc-card-value]');
    if (gcValue) gcValue.textContent = v.short;
    cta.disabled = !v.available;
    /* Vorbestellung (snippets/cmp-preorder): Worte, zweite Zeile (--cmp-preorder-ship), der Satz darunter und die
       Eigenschaft „Vorbestellung: Versand ab …“ folgen der gewählten Variante. */
    var preorder = v.available && v.preorder;
    cta.textContent = !v.available ? root.dataset.tSoldOut : preorder ? root.dataset.tPreorder : root.dataset.tAdd;
    cta.classList.toggle('cmp-pdp__cta--preorder', preorder);
    if (v.ship) cta.style.setProperty('--cmp-preorder-ship', JSON.stringify(v.ship));
    var scarcity = root.querySelector('[data-cmp-preorder-scarcity]');
    if (scarcity) scarcity.hidden = !preorder || v.left != null || v.restock != null;
    stock(v);
    var property = root.querySelector('[data-cmp-preorder-property]');
    if (property) {
      property.disabled = !v.preorder;
      if (v.property) property.value = v.property;
    }
    /* Ihr Datum, versteckt (`_ships_from`, #649), folgt mit ihr. */
    var shipsFrom = root.querySelector('[data-cmp-preorder-ships-from]');
    if (shipsFrom) {
      shipsFrom.disabled = !v.preorder;
      if (v.shipsFromProperty) shipsFrom.value = v.shipsFromProperty;
    }
    /* Eine Absage galt der vorigen Variante. */
    var buyMessage = root.querySelector('[data-cmp-buy-message]');
    if (buyMessage) buyMessage.hidden = true;
    var gpsrSku = document.querySelector('[data-cmp-gpsr-sku]');
    var gpsrCard = document.querySelector('[data-cmp-gpsr-sku-card]');
    if (gpsrSku && gpsrCard) {
      if (v.sku) { gpsrSku.textContent = v.sku; gpsrCard.hidden = false; }
      else { gpsrCard.hidden = true; }
    }
  }
  /* Die Optionen hängen voneinander ab wie ihre Reihenfolge: Carrier Colour vor Size. Ein
     Wert ist erreichbar, wenn es eine Variante mit ihm und den Werten aller Optionen
     davor gibt; die anderen stehen `aria-disabled` da und lassen sich nicht wählen
     (#20). Ausverkauft ist etwas anderes und bleibt wählbar. Die Leine, mit nur einer
     Option, geht denselben Weg. */
  function markReachable() {
    var sel = selected();
    groups.forEach(function (g) {
      var index = Number(g.dataset.cmpOption);
      g.querySelectorAll('[data-cmp-value]').forEach(function (b) {
        var reachable = variants.some(function (v) {
          return v.options[index] === b.dataset.cmpValue && matches(v, sel, index);
        });
        b.classList.toggle('is-unreachable', !reachable);
        if (reachable) b.removeAttribute('aria-disabled');
        else b.setAttribute('aria-disabled', 'true');
      });
    });
  }
  function activate(btn) {
    var group = btn.closest('[data-cmp-option]');
    group.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    group.querySelectorAll('[data-cmp-value]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
    var colorLabel = root.querySelector('[data-cmp-color-label]');
    if (group.classList.contains('cmp-pdp__swatches') && colorLabel) colorLabel.textContent = btn.dataset.cmpValue;
    var sizeLabel = root.querySelector('[data-cmp-size-label]');
    var sizeHint = root.querySelector('[data-cmp-size-hint]');
    if (group.classList.contains('cmp-pdp__sizes')) {
      if (sizeLabel) sizeLabel.textContent = btn.dataset.cmpValue;
      if (sizeHint) sizeHint.textContent = hints[btn.dataset.cmpValue] || '';
    }
  }
  /* Ein Optionswert wird gewählt — per Klick hier oder auf Wunsch des Konfigurators
     (unten). Beides geht durch diese eine Funktion, damit Label, Preis, `id`, CTA und
     SKU nie auf zwei Wegen nachgezogen werden. Gibt es die neue Kombination nicht,
     rücken die Optionen dahinter auf eine Variante, die es gibt — eine lieferbare,
     wenn möglich —, statt dass die Seite weiter die vorige beschreibt (#20). */
  function choose(btn) {
    if (btn.getAttribute('aria-disabled') === 'true') return;
    activate(btn);
    var sel = selected();
    if (!findVariant(sel)) {
      var index = Number(btn.closest('[data-cmp-option]').dataset.cmpOption);
      var fits = variants.filter(function (v) { return matches(v, sel, index + 1); });
      var target = fits.find(function (v) { return v.available; }) || fits[0];
      if (target) {
        groups.forEach(function (g) {
          var i = Number(g.dataset.cmpOption);
          if (i <= index) return;
          var match = Array.prototype.find.call(g.querySelectorAll('[data-cmp-value]'), function (b) {
            return b.dataset.cmpValue === target.options[i];
          });
          if (match) activate(match);
        });
      }
    }
    markReachable();
    update();
    /* Buchstaben-Farbprodukt: jeder Buchstabe hat sein eigenes Bild */
    if (btn.closest('.cmp-pdp__swatches') || btn.closest('.cmp-pdp__letters')) showVariantImage(true);
  }
  /* Eine im Sheet gewählte Carrier Colour (#9): der Konfigurator schreibt die gewählte
     Variante nie selbst, er bittet diese Sektion um die Farbe — per Name, aufgelöst
     gegen die hier gewählte Größe. Angewandt wie ein Klick auf den Swatch; `update()`
     setzt dann `data-cmp-carrier-variant`, und darüber erfährt der Konfigurator die
     Antwort. Eine Farbe, die es hier nicht als Swatch gibt, ändert nichts. Gibt es
     die Farbe in dieser Größe nicht, rückt die Größe nach wie bei einem Klick (#20);
     das Sheet fragt nach so einer Farbe aber gar nicht erst: es hat keine Größenwahl,
     auf der das Nachrücken zu sehen wäre, und sperrt sie deshalb.
     Ein wiederhergestellter Draft fragt bei einem Besuch ohne `?variant=` einmal nach
     Farbe *und* Größe, auf denen er zusammengestellt wurde (#77): `detail.size`, erst
     die Farbe, dann die Größe, beides wie ein Klick. Eine Größe, die es hier nicht
     gibt, ändert nichts. */
  function valueButton(selector, value) {
    return Array.prototype.find.call(
      root.querySelectorAll(selector + ' [data-cmp-value]'),
      function (b) { return b.dataset.cmpValue === value; }
    );
  }
  /* Beim Laden: die Zweite-Charge-Hinweise der Variante, die die Seite zeigt. */
  var shownVariant = findVariant(selected());
  if (shownVariant) {
    var shownScarcity = root.querySelector('[data-cmp-preorder-scarcity]');
    if (shownScarcity && (shownVariant.left != null || shownVariant.restock != null)) shownScarcity.hidden = true;
    stock(shownVariant);
  }
  root.addEventListener('cmp:choose-carrier-colour', function (e) {
    var detail = e.detail || {};
    var swatch = valueButton('.cmp-pdp__swatches', detail.carrierColour);
    if (!swatch) return;
    choose(swatch);
    var size = detail.size == null ? null : valueButton('.cmp-pdp__sizes', detail.size);
    if (size) choose(size);
  });
  root.addEventListener('click', function (e) {
    /* Eine Farbe aus der Box „Ihr wart schneller als wir“: gewählt wie eine im Sheet, über dasselbe Event, damit
       auch „Dein Perfect Match“ (cmp-set-card.js) der neuen Farbe folgt; die Karte hört sonst nur Klicks auf die
       Swatches. */
    var alt = e.target.closest('[data-cmp-restock-alt]');
    if (alt) {
      alt.dispatchEvent(new CustomEvent('cmp:choose-carrier-colour', {
        bubbles: true,
        detail: { carrierColour: alt.dataset.cmpRestockAlt },
      }));
      return;
    }
    var btn = e.target.closest('[data-cmp-value]');
    if (btn) {
      choose(btn);
      return;
    }
    var thumb = e.target.closest('[data-cmp-thumb]');
    if (thumb) goToImage(thumb.dataset.cmpThumb, true);
  });

  /* ── Galerie: Wischen (Scroll-Snap), Vorschaubilder, Farbwahl → Bild ── */
  var track = root.querySelector('[data-cmp-track]');
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-cmp-slide]')) : [];
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-cmp-thumb]'));
  // Sobald Bilder einer Farbe gehören: nur die der gewählten Farbe (vorne) und die ohne Farbe (dahinter) zeigen
  var filterMode = slides.some(function (sl) { return sl.dataset.cmpColors !== ''; });
  var thumbBox = root.querySelector('[data-cmp-thumb-label]');
  function numberThumbs() {
    if (!thumbBox) return;
    var n = 0;
    thumbs.forEach(function (t) {
      if (!t.hidden) t.setAttribute('aria-label', thumbBox.dataset.cmpThumbLabel.replace('%N%', String(++n)));
    });
  }
  function markThumb(id) {
    thumbs.forEach(function (t) {
      var on = t.dataset.cmpThumb === id;
      t.classList.toggle('is-active', on);
      if (on && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        // ohne Animation: zwei gleichzeitige smooth-Scrolls brechen sich in Chrome gegenseitig ab
        t.parentNode.scrollLeft = t.offsetLeft - t.parentNode.clientWidth / 2 + t.offsetWidth / 2;
      }
    });
  }
  function goToImage(id, smooth) {
    var sl = slides.find(function (x) { return x.dataset.cmpSlide === id && !x.hidden; });
    if (!sl || !track) return;
    markThumb(id);
    track.scrollTo({ left: sl.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  }
  function inDocumentOrder(a, b) {
    return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
  }
  // Dieselbe Regel wie die Durchgänge im Liquid oben, für eine Farbe, die erst hier gewählt wird
  function filterColor(color) {
    if (!filterMode || !color) return;
    var needle = '|' + color + '|';
    var passes = [[], [], []];
    slides.forEach(function (sl) {
      var c = sl.dataset.cmpColors;
      var pass = c === '' ? 2 : c.indexOf(needle) !== -1 ? 1 : 3;
      sl.hidden = pass === 3;
      var t = thumbs.find(function (x) { return x.dataset.cmpThumb === sl.dataset.cmpSlide; });
      if (t) t.hidden = pass === 3;
      passes[pass - 1].push({ slide: sl, thumb: t });
    });
    // Durchgang für Durchgang ans Ende gehängt, je in ihrer bisherigen Reihenfolge
    passes[0].concat(passes[1], passes[2]).forEach(function (o) {
      track.appendChild(o.slide);
      if (o.thumb) o.thumb.parentNode.appendChild(o.thumb);
    });
    slides.sort(inDocumentOrder);
    thumbs.sort(inDocumentOrder);
    numberThumbs();
  }
  function showVariantImage(smooth) {
    /* Eine Seite, die Loose Builds verkauft (#496), zeigt ihre Bilder in ihrer Reihenfolge, keines folgt einer Variante. */
    if (!track || root.querySelector('[data-cmp-gallery-fixed]')) return;
    var sel = selected();
    var cg = root.querySelector('.cmp-pdp__swatches[data-cmp-option]');
    filterColor(cg ? sel[Number(cg.dataset.cmpOption)] : null);
    var v = findVariant(sel);
    var first = slides.find(function (x) { return !x.hidden; });
    var hasOwn = v && v.image && slides.some(function (x) { return x.dataset.cmpSlide === v.image && !x.hidden; });
    var target = hasOwn ? v.image : first && first.dataset.cmpSlide;
    if (target) goToImage(target, smooth);
  }
  if (track) {
    var scrollTick = null;
    track.addEventListener('scroll', function () {
      if (scrollTick) cancelAnimationFrame(scrollTick);
      scrollTick = requestAnimationFrame(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var cur = slides.find(function (x) { return !x.hidden && x.offsetLeft <= mid && x.offsetLeft + x.offsetWidth > mid; });
        if (cur) thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.cmpThumb === cur.dataset.cmpSlide); });
      });
    }, { passive: true });
    showVariantImage(false);
    /* Mit der Maus wischen (Daniel, 2026-10-11): gedrückt halten und ziehen; beim Loslassen rastet das nächste
       Bild in Zugrichtung ein. Finger wischen weiter nativ über Scroll-Snap. Wie das Ziehen der Bewertungen
       (cmp-bewertungen): ab 5 px, erst dann eingefangen, und der Klick nach dem Ziehen zählt nicht. */
    var DRAG_FROM = 5;
    // Ab diesem Anteil der Bildbreite gilt ein Zug als Wisch zum Nachbarbild
    var SWIPE_SHARE = 0.15;
    var GLIDE_MS = 320;
    var drag = null;
    var glide = null;
    function shownSlides() { return slides.filter(function (x) { return !x.hidden; }); }
    // Die Nachbarbilder schon beim Greifen laden, sonst blitzt beim Ziehen der leere Hintergrund auf
    function loadAround(at) {
      var shown = shownSlides();
      [at - 1, at, at + 1].forEach(function (i) {
        var img = shown[i] && shown[i].querySelector('img');
        if (img) img.loading = 'eager';
      });
    }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (glide) cancelAnimationFrame(glide);
      glide = null;
      drag = { x: e.clientX, left: track.scrollLeft, moved: false };
      loadAround(Math.round(track.scrollLeft / track.clientWidth));
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      // Ohne Einfangen (noch nicht, oder es schlug fehl) kam ein Loslassen neben der Bildleiste hier nicht an
      if (!(e.buttons & 1)) {
        endDrag(e);
        return;
      }
      if (!drag.moved) {
        if (Math.abs(dx) <= DRAG_FROM) return;
        drag.moved = true;
        track.classList.add('is-dragging');
        track.style.scrollSnapType = 'none';
        try {
          track.setPointerCapture(e.pointerId);
        } catch (error) {}
      }
      track.scrollLeft = drag.left - dx;
    });
    function swallowClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    function endDrag(e) {
      if (!drag) return;
      var d = drag;
      drag = null;
      track.classList.remove('is-dragging');
      if (!d.moved) {
        track.style.scrollSnapType = '';
        return;
      }
      track.addEventListener('click', swallowClick, { capture: true, once: true });
      setTimeout(function () { track.removeEventListener('click', swallowClick, { capture: true }); }, 50);
      // Ein abgebrochener Zug (pointercancel, clientX dann oft 0) federt zurück auf das Bild, auf dem er begann
      var dx = e.type === 'pointercancel' ? 0 : e.clientX - d.x;
      var shown = shownSlides();
      var at = shown.findIndex(function (x) { return x.offsetLeft >= d.left - 1; });
      if (at < 0) at = 0;
      if (Math.abs(dx) > track.clientWidth * SWIPE_SHARE) at += dx < 0 ? 1 : -1;
      at = Math.max(0, Math.min(shown.length - 1, at));
      markThumb(shown[at].dataset.cmpSlide);
      // Selbst gleiten (ease-out, GLIDE_MS) und erst danach wieder einrasten: schaltet man Scroll-Snap vorher
      // ein, springt das Bild erst zum nächsten Rastpunkt und gleitet dann, das flackert.
      var from = track.scrollLeft;
      var to = shown[at].offsetLeft;
      var start = null;
      function step(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / GLIDE_MS);
        track.scrollLeft = from + (to - from) * (1 - Math.pow(1 - t, 3));
        if (t < 1) {
          glide = requestAnimationFrame(step);
        } else {
          glide = null;
          track.style.scrollSnapType = '';
        }
      }
      glide = requestAnimationFrame(step);
    }
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  }


  markReachable();

  /* Overlays an <body> verschieben — Horizon-Sektionswrapper erzeugen einen
     Stacking-Context (Scroll-Animation), der position:fixed-Overlays einfängt. */
  document.querySelectorAll('.cmp-modal[data-cmp-modal]').forEach(function (m) {
    document.body.appendChild(m);
  });


  // Hintergrund sperren, solange ein Info-Fenster offen ist (sonst scrollt die Seite beim Wischen neben dem Fenster mit)
  function closeModal(m) {
    m.classList.remove('is-open');
    document.documentElement.classList.remove('cmp-scroll-lock');
    setTimeout(function () { m.hidden = true; }, 220);
  }
  document.addEventListener('click', function (e) {
    var mOpen = e.target.closest('[data-cmp-modal-open]');
    if (mOpen) {
      var modal = document.querySelector('[data-cmp-modal="' + mOpen.dataset.cmpModalOpen + '"]');
      if (modal) {
        modal.hidden = false;
        document.documentElement.classList.add('cmp-scroll-lock');
        requestAnimationFrame(function () { requestAnimationFrame(function () { modal.classList.add('is-open'); }); });
      }
      return;
    }
    if (e.target.closest('[data-cmp-modal-close]')) {
      var openModal = e.target.closest('.cmp-modal');
      if (openModal) closeModal(openModal);
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.cmp-modal.is-open').forEach(closeModal);
  });

  /* A/B-Vorschau des Vertrauens-Blocks per ?trust=a|b (überschreibt die Section-Einstellung nur in der Ansicht) */
  var trustQ = new URLSearchParams(location.search).get('trust');
  if (trustQ === 'a' || trustQ === 'b') {
    root.querySelectorAll('[data-cmp-trust]').forEach(function (el) { el.hidden = el.dataset.cmpTrust !== trustQ; });
  }

  /* Voraussichtliche Lieferung (Daniel 2026-09-23): Versand am Bestelltag, Abholung durch den Paketdienst
     nur Mo–Fr (Sa/So-Bestellungen starten montags). Zugestellt wird Mo–Sa (Werktage inkl. Samstag).
     Anzeige: Versandtag + min … max Zustelltage, z. B. Mi → Fr bis Sa. Datum in Shop-Sprache. */
  var dl = root.querySelector('[data-cmp-delivery]');
  if (dl) {
    var shipDay = new Date();
    while (shipDay.getDay() === 0 || shipDay.getDay() === 6) shipDay.setDate(shipDay.getDate() + 1);
    var addWorkdays = function (n) {
      var d = new Date(shipDay);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; }
      return d;
    };
    var fmt = new Intl.DateTimeFormat(document.documentElement.lang || 'de', { weekday: 'long', day: 'numeric', month: 'long' });
    dl.innerHTML = dl.dataset.tpl
      .replace('%FROM%', fmt.format(addWorkdays(Number(dl.dataset.min))))
      .replace('%TO%', fmt.format(addWorkdays(Number(dl.dataset.max))));
    dl.hidden = false;
  }

})();
